import MovementsPage from './MovementsPage'

export default MovementsPage
